module.exports = __webpack_public_path__ + "img/reliable-b-m-s.e1e97503.svg";